import { render } from "./thunder.vue?vue&type=template&id=06a33d3d"
import script from "./thunder.vue?vue&type=script&lang=js"
export * from "./thunder.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__